import { useContext, useState, useEffect } from "react";
import { AuthContext } from "./AuthContext";

export interface IProps {
    requriedRole: string[];
}
export default function RoleCheck({ children, requriedRole }: React.PropsWithChildren<IProps>) {
    const { checkRole, userDetails } = useContext(AuthContext);
    const [passed, setPassed] = useState(false);

    useEffect(() => {
        if (requriedRole.length == 0) {
            setPassed(true);
            return;
        }
        else {
            const isAuthorized = checkRole(requriedRole);
            setPassed(isAuthorized);
        }
    }, [userDetails?.role]);

    return (
        <>
            {passed ?
                children
                :
                <></>}
        </>
    );
}